<template>
  <h2>Abmeldungen</h2>
  <AbsenceCalendar
    :servers="servers"
    :absences="absenceStore.data"
    @create="onCreate"
    @update="onUpdate"
    @delete="onDelete"
  />
</template>

<script>
import AbsenceCalendar from "@/components/AbsenceCalendar.vue";
import {useAltarServerStore} from "@/stores/altarServer";
import {useAbsenceStore} from "@/stores/absence";

export default {
  name: "VueAbsences",
  components: {AbsenceCalendar},
  setup() {
    return {
      altarServerStore: useAltarServerStore(),
      absenceStore: useAbsenceStore(),
    };
  },
  computed: {
    servers() {
      return this.altarServerStore.sortedData
        .filter(a => a.active && a.altarServer)
        .map(a => ({id: a.id, planname: a.planname}));
    },
  },
  methods: {
    async onCreate({altarServers, startDate, endDate}) {
      await this.absenceStore.bulkCreateAbsences({
        altarServers,
        dateRanges: [{startDate, endDate}],
      });
    },
    async onUpdate(absence) {
      await this.absenceStore.updateItem(absence);
      await this.absenceStore.getData();
    },
    async onDelete(absence) {
      await this.absenceStore.deleteItem(absence, false);
    },
  },
  async created() {
    if (!this.altarServerStore.loadedData) await this.altarServerStore.getData();
    await this.absenceStore.getData();
  },
};
</script>
